export default __webpack_public_path__ + "static/media/Asset 24.f144005c.png";